import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { SparklesIcon, BrainIcon, UnlockIcon } from 'lucide-react';
export function AHASection() {
  return <SectionWrapper id="revelacion" withGlow glowPosition="top" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 mb-8 bg-gradient-to-r from-[#c9a84c]/20 to-[#f0d060]/20 border border-[#c9a84c]/40 rounded-full" data-id="element-4">
            <SparklesIcon className="w-5 h-5 text-[#f0d060]" aria-hidden="true" data-id="element-5" />
            <span className="text-[#f0d060] text-sm md:text-base font-bold tracking-wide uppercase" data-id="element-6">
              El 1% que falta
            </span>
          </div>

          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8e6e1] mb-8 leading-tight" data-id="element-7">
            Tu problema no es{' '}
            <span className="line-through text-[#6b6b7b]" data-id="element-8">
              falta de disciplina
            </span>
            <br data-id="element-9" />
            Es tu{' '}
            <span className="text-gold-gradient" data-id="element-10">identidad subconsciente</span>
          </h2>
        </div>

        <div className="bg-[#16213e]/80 border-2 border-[#c9a84c]/30 rounded-2xl p-8 md:p-12 mb-12" data-id="element-11">
          <div className="flex items-start gap-4 mb-6" data-id="element-12">
            <BrainIcon className="w-8 h-8 text-[#c9a84c] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-13" />
            <div data-id="element-14">
              <h3 className="text-xl md:text-2xl font-display font-bold text-[#e8e6e1] mb-4" data-id="element-15">
                Aquí está lo que realmente pasa:
              </h3>
              <p className="text-lg text-[#9a9aab] leading-relaxed mb-4" data-id="element-16">
                Tu cerebro tiene un{' '}
                <span className="text-[#e8e6e1] font-medium" data-id="element-17">
                  sistema de identidad
                </span>{' '}
                programado durante años por tus experiencias, creencias
                heredadas y patrones repetidos.
              </p>
              <p className="text-lg text-[#9a9aab] leading-relaxed mb-4" data-id="element-18">
                Este sistema opera en tu{' '}
                <span className="text-[#c9a84c] font-medium" data-id="element-19">
                  subconsciente
                </span>{' '}
                — el 95% de tu mente que controla tus decisiones automáticas.
              </p>
              <p className="text-lg text-[#e8e6e1] leading-relaxed font-medium" data-id="element-20">
                Cada vez que intentas cambiar con fuerza de voluntad, tu
                subconsciente te regresa al "programa original" porque eso es lo
                que reconoce como "tú".
              </p>
            </div>
          </div>

          <div className="border-t border-[#3a3a5c] pt-6 mt-6" data-id="element-21">
            <p className="text-xl md:text-2xl text-center font-display text-[#c9a84c] font-bold" data-id="element-22">
              No necesitas más motivación.
              <br data-id="element-23" />
              <span className="text-[#e8e6e1]" data-id="element-24">
                Necesitas reprogramar el código fuente de tu identidad.
              </span>
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-25">
          <div className="text-center p-6 rounded-xl bg-[#16213e]/60 border border-[#3a3a5c]/50" data-id="element-26">
            <div className="w-12 h-12 rounded-full bg-[#c9a84c]/10 flex items-center justify-center mx-auto mb-4" data-id="element-27">
              <span className="text-2xl font-bold text-[#c9a84c]" data-id="element-28">95%</span>
            </div>
            <p className="text-[#9a9aab] text-sm" data-id="element-29">
              De tus decisiones son{' '}
              <span className="text-[#e8e6e1] font-medium" data-id="element-30">subconscientes</span>
            </p>
          </div>

          <div className="text-center p-6 rounded-xl bg-[#16213e]/60 border border-[#3a3a5c]/50" data-id="element-31">
            <div className="w-12 h-12 rounded-full bg-[#c9a84c]/10 flex items-center justify-center mx-auto mb-4" data-id="element-32">
              <UnlockIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-33" />
            </div>
            <p className="text-[#9a9aab] text-sm" data-id="element-34">
              La{' '}
              <span className="text-[#e8e6e1] font-medium" data-id="element-35">
                neuroplasticidad
              </span>{' '}
              permite reprogramar tu cerebro
            </p>
          </div>

          <div className="text-center p-6 rounded-xl bg-[#16213e]/60 border border-[#3a3a5c]/50" data-id="element-36">
            <div className="w-12 h-12 rounded-full bg-[#c9a84c]/10 flex items-center justify-center mx-auto mb-4" data-id="element-37">
              <span className="text-2xl font-bold text-[#c9a84c]" data-id="element-38">21</span>
            </div>
            <p className="text-[#9a9aab] text-sm" data-id="element-39">
              Días para{' '}
              <span className="text-[#e8e6e1] font-medium" data-id="element-40">instalar</span> una
              nueva identidad
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}